<template>
  <div id="deviceFreeForExchange" class="custom-scroll">
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <CRow class="mb-3 search-panel">
          <CCol xs="12" sm="6" md="4" lg="4" xl="3">
            <BaseInput
                :options="codeInput.options"
                :data="codeInput.data"
                :listener="codeInput.listener"
            />
          </CCol>
          <CCol>
            <div class="form-group">
              <label style="color: white"></label>
              <div>
                <CButton
                    style="float: right; margin-left: 5px"
                    color="primary"
                    v-c-tooltip.hover="'Tải lại'"
                    class="btn-action-primary"
                    @click="loadDataDevice(true)">
                  <i class="fa fa-refresh"></i>&nbsp; Tải lại
                </CButton>
              </div>
            </div>
          </CCol>
        </CRow>

        <CDataTable
            class="custom-scroll"
            :items="mainTable.items"
            :fields="mainTable.options.fields"
            :sorter="true"
            :loading="loading.value"
            :sorterValue="{ column: null, asc: 'true' }"
            :tableFilter="{ label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm', external: false}"
            :itemsPerPageSelect="{label: ' ', values: [10, 15, 20, 50], external: true}"
            :clickableRows="true"
            :hover="true"
            @pagination-change="changeItemPerPage"
            @row-clicked="rowClickTable">
          <template #index="{ index, item }">
            <td class="action-btn-group">
              <CInputRadio
                  type="radio"
                  addInputClasses="override-custom"
                  custom
                  :value="item.id"
                  name="deviceFreeExchangeSelected"
                  :checked="item.isSelected"
              />
            </td>
          </template>
          <template #updateDate="{ item }">
            <td>
              {{ $helper.formatDateDDMMYYYYHHMM(item.updateDate) }}
            </td>
          </template>
          <template #code="{item}">
            <td>
              <span :key="item.code" v-c-tooltip:hover="item.code" class="description">
                {{ item.code }}<br/>
              </span>
            </td>
          </template>
          <template #phoneNumber="{item}">
            <td>
              <span v-if="item.phoneNumber != null && item.phoneNumber != ''"
                    :key="item.phoneNumber"
                    v-c-tooltip:hover="{ content : getInformationPhone(item), placement: 'right' }">{{
                  item.phoneNumber
                }}</span>
              <span v-else class="badge badge-light">Chưa xác định</span>
            </td>
          </template>
          <template #connectStatus="{item}">
            <td>
              <span class="badge badge-success" v-if="item.connectStatus == 1">Kết nối</span>
              <span class="badge badge-danger" v-if="item.connectStatus == 0">Mất kết nối</span>
            </td>
          </template>
          <template slot="no-items-view">
            <span style="color: #969696">Danh sách trống!</span>
          </template>
          <template slot="loading">
            <BaseFormLoading :loading="true"></BaseFormLoading>
          </template>
        </CDataTable>

        <div v-if="pagination && pagination.totalElement !== 0">
          <div style="display:flex; flex-wrap:wrap;">
            <div style="font-size:.95em;color:gray; padding-left:.75rem;">
              {{ fromElement }}-{{ toElement }} /
              {{ pagination.totalElement }} bản ghi
            </div>
            <nav style="margin-left:auto;">
              <CPagination
                  @update:activePage="updateActivePage"
                  :activePage.sync="pagination.activePage"
                  :pages="pagination.pages"
                  :total-rows="pagination.totalRows"
                  :per-page="pagination.pageSize"
                  prev-text="Prev"
                  next-text="Next"
                  hide-goto-end-buttons/>
            </nav>
          </div>
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import BaseTable from "@/views/base/BaseDataTable";
import ModalConfirm from "@/views/base/BaseModalConfirm";
import BaseInput from "@/views/base/BaseInput";
import BaseSelect from "@/views/base/BaseSelect2";
import BaseFormLoading from "@/views/base/BaseFormLoading";
import BaseModal from "@/views/base/BaseModal";
import {DatePicker} from "v-calendar";
import VideoPlayer from "@/views/base/VideoPlayer";
import Multiselect from "vue-multiselect";

export default {
  name: "DeviceFreeForExchange",
  props: {
    title: String
  },
  components: {
    BaseFormLoading,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect,
    DatePicker,
    BaseModal,
    VideoPlayer,
    Multiselect
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;
    return {
      loading: {
        value: false,
      },
      codeInput: {
        options: {
          placeholder: "Mã thiết bị",
          label: "Mã thiết bị",
        },
        data: {
          name: "code",
          model: "",
        },
        listener: {
          keyup: function (event) {
            if (event.key === "Enter") {
              that.loadDataDevice();
            }
          },
          blur: function () {
            that.loadDataDevice();
          },
        }
      },
      mainTable: {
        options: {
          fields: [
            {key: "index", label: "#", sorter: false, filter: false},
            {key: "updateDate", label: "Cập nhật cuối"},
            {key: "code", label: "Mã thiết bị"},
            {key: "connectStatus", label: "Trạng thái kết nối", sorter: true, filter: true},
            {key: "phoneNumber", label: "Số thuê bao/IP", sorter: true, filter: true},
          ],
          slots: [
            "index", "updateDate", "code", "phoneNumber", "connectStatus"
          ],
          sorter: true,
          columnFilter: false,
        },
        items: [],
      },
      pagination: {
        activePage: 1,
        pages: 1,
        pageSize: 10,
        totalElement: 0,
        totalRows: 0
      },
      itemChooseFileSelected: ''
    };
  },
  methods: {
    getInformationPhone(item) {
      let response = `<div class="text-left"><div><b>Nhà mạng:</b> ${item.networkProvider}</div>
                       <div><b>IMEI:</b> ${item.phoneImei}</div>`;
      if (item.phoneDataCapacity != null) {
        response += `<div><b>Dung lượng:</b> ${item.phoneDataCapacity}</div>`;
      }
      if (item.phoneDateActive) {
        response += `<div><b>Data có hiệu lực:</b> ${this.$helper.formatDateDDMMYYYY(item.phoneDateActive)}</div>`;
      }
      if (item.phoneDateExpired) {
        response += `<div><b>Data hết hiệu lực:</b> ${this.$helper.formatDateDDMMYYYY(item.phoneDateExpired)}</div>`;
      }
      if (item.dateWarranty) {
        response += ` <div> <b>Thời hạn bảo hành:</b> ${this.$helper.formatDateDDMMYYYY(moment(item.dateWarranty).add(1, 'y'))} </div>`;
      }
      response += '</div>';
      return response;
    },
    loadDataDevice(isRefresh) {
      let that = this;
      that.loading.value = true;
      that.$helper.loadDataSource({
        url: "/devices/getPagesDeviceFreeForExchange",
        dataSubmit: function () {
          var params = that.$helper.setupDataSubmit(that.$data);
          params.pageSize = that.pagination.pageSize;
          params.pageNumber = that.pagination.activePage - 1;
          params.code = that.codeInput.data.model;
          params.isDevice = 1;
          params.connectStatus = -1;
          params.activeStatus = -1;
          return params;
        },
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            if (!isRefresh) {
              that.mainTable.items = [];
            }
            let _data = response.data.data;
            _data.dataContent.content.map((each) => {
              if (that.itemChooseFileSelected != null && that.itemChooseFileSelected != ''
                  && that.itemChooseFileSelected.id && each.id == that.itemChooseFileSelected.id) {
                each.isSelected = true;
              } else {
                each.isSelected = false;
              }
              that.mainTable.items.push(each);
            });
            that.setupPagination(_data);
            that.isShow = true;
          }
          that.loading.value = false;
        },
        errorCallback: function (error) {
          that.loading.value = false;
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    updateActivePage: function (activePage) {
      this.pagination.activePage = activePage;
      this.loadDataDevice();
    },
    setupPagination(_dataResponse) {
      this.pagination.pages = Math.ceil(_dataResponse.totalElement / this.pagination.pageSize);
      this.pagination.totalElement = _dataResponse.totalElement;
    },
    rowClickTable(...args) {
      this.mainTable.items.map((item, index) => {
        if (index === args[1]) {
          item.isSelected = true;
          this.itemChooseFileSelected = item;
          this.$emit('device:selected', item);
        } else {
          item.isSelected = false;
        }
      });
    },
    changeItemPerPage(value) {
      this.pagination.activePage = 1;
      this.pagination.pageSize = value;
      this.loadDataDevice();
    },
  },
  created: function () {
  },
  mounted() {
    this.loadDataDevice();
  },
  watch: {},
  computed: {
    fromElement: function () {
      return (this.pagination.activePage - 1) * this.pagination.pageSize + 1;
    },
    toElement: function () {
      return (
          (this.pagination.activePage - 1) * this.pagination.pageSize +
          this.mainTable.items.length
      );
    },
  },
};
</script>

<style>
.row-2 .form-group {
  margin-top: 0 !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect.input-error .multiselect__tags {
  border-color: #ff7070;
}
</style>
<style lang="scss">

#deviceFreeForExchange {
  .form-check-input {
    width: 16px;
    height: 16px;
  }

  .multiselect {
    min-height: 36px !important;
    margin-top: -2px;

    &.input-error .multiselect__tags {
      border-color: #ff7070;
    }

    .valid-error {
      animation: fade-down ease-out .2s;
      animation-fill-mode: forwards;
    }

    .multiselect__tags {
      padding-top: 0px !important;
      min-height: 36px !important;
    }


    .multiselect__tag {
      margin-top: 5px !important;
      margin-bottom: 0 !important;
    }
  }

  .multiselect__input {
    line-height: unset !important;
    font-size: 14px !important;
    padding-top: 5px !important;
  }


  .multiselect__placeholder {
    padding-top: 7px !important;
    margin: 0 !important;
  }

  .override-custom {
    opacity: 0 !important;
  }
}
</style>
